import { useMutation, useQuery } from 'react-query'

import { fetchUserRoles, fetchCurrentUser, fetchTokenEngecomp, fetchUserLogins, fetchUserAcessos, fetchUserAcessosPorDia, fetchUserAnalytics, fetchUsers, fetchUsersAnalyticsGeral } from 'api/clients/users'

export const useUserRoles = () => useQuery('user_roles', () => fetchUserRoles())

export const useUsers = (params = {}) =>
  useQuery(['users', params], () => fetchUsers(params), {
    keepPreviousData: true,
    enabled: params?.enabled ?? true,
  })

export const useTokenEngecomp = () => useMutation(() => fetchTokenEngecomp())

export const useFetchCurrentUser = () => useQuery('users', () => fetchCurrentUser())

export const useUserLogins = id =>
  useQuery(['user_logins', id], () => fetchUserLogins(id))

export const useUserAcessos = (id, params = {}) =>
  useQuery(['user_acessos', id, params], () => fetchUserAcessos(id, params), {
    keepPreviousData: true,
  })

export const useUserAcessosPorDia = (id, params = {}) =>
  useQuery(['user_acessos_por_dia', id, params], () => fetchUserAcessosPorDia(id, params), {
    keepPreviousData: true,
  })

export const useUserAnalytics = id =>
  useQuery(['user_analytics', id], () => fetchUserAnalytics(id))

export const useUsersAnalyticsGeral = (params = {}, options = {}) =>
  useQuery(['users_analytics_geral', params], () => fetchUsersAnalyticsGeral(params), {
    keepPreviousData: true,
    ...options,
  })
